export default "/images/e2951321f9c0f919c96360853977e06d.avif";